import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Sidebar } from "./Sidebar";
import { motion } from "framer-motion";
import { theme } from "../theme";
import { useAuth0 } from "@auth0/auth0-react";
import { useBreakpoint } from "../hooks/useBreakpoint";
import axios from "axios";

interface LayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<LayoutProps> = ({ children }) => {
  const { user, getAccessTokenSilently } = useAuth0();
  const { isMobileOrTablet } = useBreakpoint();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [tieneContable, setTieneContable] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!user?.id_empresa) return;
    getAccessTokenSilently().then(token => {
      axios.get(
        `${process.env.REACT_APP_LIQUIDACION_URL}/verificar_empresa_contable/${user.id_empresa}/`,
        { headers: { Authorization: `Bearer ${token}` } }
      ).then(res => setTieneContable(res.data.tiene_contable === true)).catch(() => {});
    }).catch(() => {});
  }, [user?.id_empresa]);

  // Cerrar sidebar al navegar en móvil/tablet
  useEffect(() => {
    if (isMobileOrTablet) {
      setMobileOpen(false);
    }
  }, [location.pathname, isMobileOrTablet]);

  // Cerrar sidebar al pasar a desktop
  useEffect(() => {
    if (!isMobileOrTablet) {
      setMobileOpen(false);
    }
  }, [isMobileOrTablet]);

  return (
    <div
      className="flex flex-row h-screen overflow-hidden"
      style={{ backgroundColor: theme.colors.backgroundGray }}
    >
      <Sidebar
        user={user}
        mobileOpen={mobileOpen}
        onClose={() => setMobileOpen(false)}
        tieneContable={tieneContable}
      />
      <div
        className="flex-1 flex flex-col overflow-hidden"
        style={{ backgroundColor: theme.colors.backgroundGray }}
      >
        <Navbar onMenuToggle={() => setMobileOpen((o) => !o)} />
        <motion.main
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="flex-1 overflow-auto"
          style={{
            backgroundColor: theme.colors.backgroundGray,
            padding: isMobileOrTablet ? '12px' : '24px',
          }}
        >
          {children}
        </motion.main>
      </div>
    </div>
  );
};
